import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Time } from 'huddyapi';
import { Filter } from './filter';


@Component({
  selector: 'patient-list-filter',
  templateUrl: 'patient-list-filter.html',
  styleUrls: ["./patient-list-filter.scss"]
})
export class PatientListFilter {
 
  @Input() filter : Filter;
  @Input() numFilters : number;
  @Output() editingDone: EventEmitter<void> = new EventEmitter<void>();
  @Output() removeFilter: EventEmitter<Filter> = new EventEmitter<Filter>();
  edited : Filter = new Filter();
  datePickerDate = new Date();

  constructor  (private cd : ChangeDetectorRef) {
  }

  columns : Column[] = [
    {
      displayName : "Identifier",
      value : "identifier",
      operators : [
        {
          displayName: "equals",
          value: "="
        },
        {
          displayName: "contains",
          value: "^"
        }
      ],
      valueStyle : "text"
    },
    {
      displayName : "Name",
      value : "friendlyName",
      operators : [
        {
          displayName: "is",
          value: "="
        }
      ],
      valueStyle : "text"
    },
    {
      displayName : "Provider Name",
      value : "providerName",
      operators : [
        {
          displayName: "is",
          value: "^"
        }
      ],
      valueStyle : "text"
    },
    {
      displayName : "Conditions",
      value : "conditions",
      operators : [
        {
          displayName: "is",
          value: "^"
        }
      ],
      valueStyle : "text"
    },
    {
      displayName : "Compasses",
      value : "compasses",
      operators : [
        {
          displayName: "is",
          value: "^"
        }
      ],
      valueStyle : "text"
    },
    {
      displayName : "Address",
      value : "address",
      operators : [
        {
          displayName: "contains",
          value: "^"
        }
      ],
      valueStyle : "text"
    },
    {
      displayName : "Phone",
      value : "phone",
      operators : [
        {
          displayName: "contains",
          value: "^"
        }
      ],
      valueStyle : "text"
    },
    {
      displayName : "Tags",
      value : "tags",
      operators : [
        {
          displayName: "contains",
          value: "^"
        }
      ],
      valueStyle : "text"
    },
    {
      displayName : "Teams",
      value : "teams",
      operators : [
        {
          displayName: "contains",
          value: "^"
        }
      ],
      valueStyle : "text"
    },
    {
      displayName : "Family Identifier",
      value : "familyIdentifiers",
      operators : [
        {
          displayName: "contains",
          value: "^"
        }
      ],
      valueStyle : "text"
    },
    {
      displayName : "Last Assigned Date",
      value : "lastAssignedDt",
      operators : [
        {
          displayName: "after",
          value: ">"
        },
        {
          displayName: "before",
          value: "<"
        },
        {
          displayName: "exists",
          value: "~"
        },
        {
          displayName: "does not exist",
          value: "}"
        }
      ],
      valueStyle : "datepicker"
    },
    {
      displayName : "Last Logged",
      value : "lastMeasurement",
      operators : [
        {
          displayName: "after",
          value: ">"
        },
        {
          displayName: "before",
          value: "<"
        },
        {
          displayName: "exists",
          value: "~"
        },
        {
          displayName: "does not exist",
          value: "}"
        }
      ],
      valueStyle : "datepicker"
    },
    {
      displayName : "Last Assessment Date",
      value : "lastAssessmentDt",
      operators : [
        {
          displayName: "after",
          value: ">"
        },
        {
          displayName: "before",
          value: "<"
        },
        {
          displayName: "exists",
          value: "~"
        },
        {
          displayName: "does not exist",
          value: "}"
        }
      ],
      valueStyle : "datepicker"
    }

  ]; 

  getSelectedOperators() : Operator[] {
    let ret : Operator[] = [];
    if (this.edited && this.edited.columnValue) {
      let match : Column = this.columns.find(c => c.value === this.edited.columnValue);
      if (match) {
        return match.operators;
      } 
    }
    return ret;
  }

  clear() {
    this.edited.columnValue = null;
    this.edited.expressionValue = null;
    this.edited.operatorValue = null;
  }

  onColumnChange($event) {
    let operators : Operator[] = this.getSelectedOperators();
    if (operators.length === 1)
      this.edited.operatorValue = operators[0].value;
  }

  getValueStyle() : string {

    if (this.edited && this.edited.columnValue) {
      let match : Column = this.columns.find(c => c.value === this.edited.columnValue);
      if (match) {
        return match.valueStyle;
      }
    }
    return '';
  }

  isDone() {
    return this.edited.columnValue && this.edited.operatorValue &&
     ((this.edited.expressionValue && this.edited.expressionValue != '') ||
     (this.edited.operatorValue === '}' || this.edited.operatorValue === '~'));
  }

  updateFilterFromEdited() {
    this.filter.columnValue = this.edited.columnValue;
    this.filter.operatorValue = this.edited.operatorValue;
    this.filter.expressionValue = this.getExpressionValue();
  }

  checkExpression($event) {
    this.edited.expressionValue = this.edited.expressionValue.replace(/[^a-zA-Z0-9 '-.]/g, '');
  }


  onSave() {
    this.onDone();
  }

 onCancel() {
  this.filter.editing = false;
  this.edited = new Filter();
  this.removeFilter.emit(this.filter);
 }

  onDone() {
    this.filter.editing = false;
    this.editingDone.emit();
  }

  getColumnDisplayName() {
    let ret : string = '';
    if (this.filter && this.filter.columnValue) {
      let column: Column = this.columns.find(f => f.value == this.filter.columnValue);
      if (column)
        ret = column.displayName;
    } 
    return ret;
  }

  getOperatorDisplayName() {
    let ret : string = '';
    if (this.filter && this.filter.columnValue && this.filter.operatorValue) {
      let column: Column = this.columns.find(f => f.value == this.filter.columnValue);
      if (column) {
        let operator: Operator = column.operators.find(o => o.value === this.filter.operatorValue);
        if (operator)
          ret = operator.displayName;
      }        
    } 
    return ret;
  }

  getExpressionValue() {
    let ret : string = '';
    if (this.filter && this.filter.columnValue && this.filter.operatorValue) {
      let column: Column = this.columns.find(f => f.value == this.filter.columnValue);
      if (column.valueStyle === 'text') {
          ret = this.edited.expressionValue;
      } else {
        let t : Time = new Time(this.edited.expressionValue);
         ret = ''+t.getUnixTimestamp();
      }       
    } 
    return ret;
  }

  remove() {
    this.removeFilter.emit(this.filter);
  }

  toggleEditing() {
    this.filter.editing = true;
  }

}

export interface Column {
  displayName : string;
  value : string;
  operators : Operator[];
  valueStyle : string;
}

export interface Operator {
  displayName : string;
  value : string;
}

